module.exports = __webpack_public_path__ + "static/media/22ESCWA17.c243ae9e.jpg";